@if (hasAerohive()) {
  <a class="shortcut-menu__button" href="https://extremecloudiq.com" target="_blank">
    <svg-icon src="assets/images/icons/out.svg"></svg-icon>
    <span>{{ "ShortcutMenu.Hive" | translate }} </span>
  </a>
}
@if (hasAruba()) {
  <a class="shortcut-menu__button" href="https://common.cloud.hpe.com/home" target="_blank">
    <svg-icon src="assets/images/icons/out.svg"></svg-icon>
    <span>{{ "ShortcutMenu.ArubaCentral" | translate }} </span>
  </a>
}
